import axios from 'axios';
import type { IAppointmentEmailDelivery } from '@bb/domain/dist/types';

export type AppointmentDeliveryLog = {
  recipient: string;
  eventType: string;
  status: string;
  time: Date;
};

const getEmailDeliveryLog = async (appointmentId: string) => {
  const { data } = await axios.get<IAppointmentEmailDelivery[]>(
    `/appointment/${appointmentId}/delivery`,
  );

  return data.map(log => ({
    recipient: log.recipient,
    eventType: log.emailType,
    status: log.event,
    time: new Date(log.receivedAt),
  })) as AppointmentDeliveryLog[];
};

export default getEmailDeliveryLog;
